const listNamesConfig = {
  entityItemsNamePlural: "Players",
  entityItemName: "Player",
  areaAccessName: "Players"
};

export default listNamesConfig;